export default "__VITE_ASSET__CS7IgY2f__"